import React, { Component } from 'react'
import { observer } from 'mobx-react';
import { Icon, Button, message, Input, List } from 'antd';
import { addLeaderboard, updateLeaderboard, getScores, getLeadersBy } from '../../api-calls/leaders';
import Blockies from 'react-blockies';
@observer(["ViewStore", "UserStore", "AuthStore"])
class Leaderboard extends Component {
    constructor(props) {
        super(props);
        let self = this;
        this.state = {
            ethWon: 0,
            leaders: [],
            loadingLeaders: true

        };        
        getLeadersBy("bets_won", 10).then((response) => {
            console.log("leaders" + JSON.stringify(response));
            self.setState({ leaders: response, loadingLeaders: false })
        });
    }
    async componentWillMount() {
        this.props.ViewStore.changeView('Leaderboard');
        this.props.ViewStore.changeCurrentPage('Leaderboard')
    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Leaderboard')
    }

    render() {
        const { UserStore } = this.props;
        const listItems = this.state.leaders.map((leader, index) =>
            <List.Item key={leader._id.toString()} style={{ padding: "15px" }}>

                <div className={index === 0 ? "leader-row leaderboard-gold" : index === 1 ? "leader-row leaderboard-silver" : index === 2 ? "leader-row leaderboard-bronze" : "leader-row"} onClick={this.handleClickEvent}>
                    <div style={{ color: (index === 0 ? '#ffd200' : index === 1 ? '#c6c6c6' : index === 2 ? '#b6954e' : "white"), borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        {index === 0 ? <img src="img/leaderboard/goldTrophy.png" style={{ width: '16px' }} />
                            : index === 1 ? <img src="img/leaderboard/silverTrophy.png" style={{ width: '14px' }} />
                                : index === 2 ? <img src="img/leaderboard/bronzeTrophy.png" style={{ width: '11px' }} /> : index + 1}
                    </div>
                    <div style={{ color: (index === 0 ? '#ffd200' : index === 1 ? '#c6c6c6' : index === 2 ? '#b6954e' : "white"), borderRight: '1px solid #3a4e53' }}>
                        {/* <img className="leaderboard-avatar-img" src="img/avatars/Buzz1man.png" /> */}
                        <Blockies scale={3} seed={leader.publicAddress} /> <span style={{ marginLeft: "5px" }}>{leader.username}</span>   <span style={{ marginLeft: "5px" }}>{index === 0 ? <img src="img/leaderboard/crown.png" style={{ width: '19px', marginRight: '5px', marginTop: '-4px' }} />
                            : index === 1 ? <img src="img/leaderboard/tiara.png" style={{ width: '24px', marginRight: '5px' }} />
                                : index === 2 ? <img src="img/leaderboard/laurel.png" style={{ width: '24px' }} /> : ""}</span>
                    </div>
                    <div style={{ color: (index === 0 ? '#ffd200' : index === 1 ? '#c6c6c6' : index === 2 ? '#b6954e' : "white") }}>
                        {leader.numBetsWon}
                    </div>
                </div>

            </List.Item>
        );

        return (
            <div className="leaderboard">
                {/* <div>
                    <div style={{ fontSize: '12px', textAlign: 'left', marginBottom: '40px', padding: '20px', color: 'rgb(109, 218, 255)' }}>
                        <img src="img/leaderboard/trophyIcon.png" style={{ marginRight: '10px', marginBottom: '3px' }} />YOU ARE CURRENTLY RANKED #{this.state.userRank} ON THE LEADERBOARD
                        </div>
                </div> */}
                <div className="leader-row leaderboard-titles">
                    <div style={{ textAlign: 'center' }}>
                        RANK
                        </div>
                    <div>
                        USERNAME
                        </div>
                    <div>
                        BETS WON
                        </div>
                    {/* <div>
                        MVU EARNED
                        </div> */}
                </div>
                {this.state.loadingLeaders ?
                    <Icon type="loading" /> :
                    <List
                        grid={{
                            gutter: 16, xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1,
                        }} >{listItems}</List>
                }
                {/* <div className="leader-row leaderboard-gold" onClick={this.handleClickEvent}>
                    <div style={{ color: '#ffd200', borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        <img src="img/leaderboard/goldTrophy.png" style={{ width: '16px' }} />
                    </div>
                    <div style={{ color: '#ffd200', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Buzz1man.png" />
                        <img src="img/leaderboard/crown.png" style={{ width: '19px', marginRight: '5px', marginTop: '-4px' }} />
                        Buzz1man
                        </div>
                    <div style={{ color: '#ffd200' }}>
                        120
                     </div>
                    <div style={{ color: '#ffd200' }}>
                        1,200 MVU
                        </div>
                </div>
                <div className="leader-row leaderboard-silver" onClick={this.handleClickEvent}>
                    <div style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        <img src="img/leaderboard/silverTrophy.png" style={{ width: '14px' }} />
                    </div>
                    <div style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/ExecMega.png" />
                        <img src="img/leaderboard/tiara.png" style={{ width: '24px', marginRight: '5px' }} />ExecMega
                            </div>
                    <div style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53' }}>
                        111
                        </div>
                    <div style={{ color: '#c6c6c6' }}>
                        1,100 MVU
                        </div>
                </div>
                <div className="leader-row leaderboard-bronze" onClick={this.handleClickEvent}>
                    <div style={{ color: '#b6954e', borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        <img src="img/leaderboard/bronzeTrophy.png" style={{ width: '11px' }} />
                    </div>
                    <div style={{ color: '#b6954e', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Quannams.png" width="30" />
                        <img src="img/leaderboard/laurel.png" style={{ width: '24px' }} />Quannams
                        </div>
                    <div style={{ color: '#b6954e', borderRight: '1px solid #3a4e53' }}>
                        104
                        </div>
                    <div style={{ color: '#b6954e' }}>
                        1,000 MVU
                        </div>
                </div>
                <div className="leader-row" onClick={this.handleClickEvent}>
                    <div style={{ borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        4
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Vivalaveca91.png" />Vivalaveca91
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        99
                        </div>
                    <div>
                        999 MVU
                        </div>
                </div>
                <div className="leader-row" onClick={this.handleClickEvent}>
                    <div style={{ borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        5
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Forboxylet.svg" />
                        Forboxylet
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        95
                        </div>
                    <div>
                        954 MVU
                        </div>
                </div>
                <div className="leader-row" onClick={this.handleClickEvent}>
                    <div style={{ borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        6
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/vividpop.png" />
                        VividPop
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        91
                        </div>
                    <div>
                        930 MVU
                        </div>
                </div>
                <div className="leader-row" onClick={this.handleClickEvent}>
                    <div style={{ borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        7
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Stevelson.png" />
                        Stevelson
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        87
                        </div>
                    <div>
                        910 MVU
                        </div>
                </div>
                <div className="leader-row" onClick={this.handleClickEvent}>
                    <div style={{ borderRight: '1px solid #3a4e53', textAlign: 'center' }}>
                        8
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Luckytone.png" />
                        Luckytone
                        </div>
                    <div style={{ borderRight: '1px solid #3a4e53' }}>
                        84
                        </div>
                    <div>
                        899 MVU
                        </div>
                </div> */}
            </div>
        );
    }
}

export default Leaderboard;


// WEBPACK FOOTER //
// ./src/components/appComponents/Leaderboard.js